import { useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';

import useNoundles from './useNoundles';

const useGenesisNoundleBalance = () => {
  const { account } = useWeb3React();
  const noundles = useNoundles();

  const [genesisNoundleBalance, setGenesisNoundleBalance] = useState(0);

  useEffect(() => {
    let ignore = false;
    setGenesisNoundleBalance(0);
    if (noundles) {
      const fetchNoundles = () => {
        noundles.balanceOf(account).then((noundleBalance) => {
          if (!ignore) setGenesisNoundleBalance(noundleBalance.toNumber());
        });
      };
      fetchNoundles();
      const transferFrom = noundles.filters.Transfer(account);
      const transferTo = noundles.filters.Transfer(null, account);
      noundles.on(transferFrom, fetchNoundles);
      noundles.on(transferTo, fetchNoundles);
      return () => {
        noundles.off(transferFrom, fetchNoundles);
        noundles.off(transferTo, fetchNoundles);
        ignore = true;
      };
    }
  }, [noundles, account]);

  return genesisNoundleBalance;
};

export default useGenesisNoundleBalance;
